import axios from "axios";
import { MAIN_URL } from "../Configurations/Urls";

export const EMPLOYEE_SETUP_ROWS = [
  {
    key: "departments",
    message: "No departments found",
    buttonLabel: "Go to Department Page",
    route: "/organization/departments",
  },
  {
    key: "designations",
    message: "No designations found",
    buttonLabel: "Go to Designation Page",
    route: "/organization/designation",
  },
  {
    key: "workShifts",
    message: "No work shifts found",
    buttonLabel: "Go to Work Shift Page",
    route: "/organization/work-shift",
  },
];

export const EMPLOYEE_ADD_ROUTE = "/organization/employee/employee-details/add";

const parseOrgList = (data, ...keys) => {
  for (const key of keys) {
    const value = data?.[key];
    if (Array.isArray(value)) return value;
    if (Array.isArray(value?.data)) return value.data;
  }
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

export const buildMissingSetup = ({
  departmentCount = 0,
  designationCount = 0,
  workShiftCount = 0,
}) => {
  const missing = {
    departments: departmentCount === 0,
    designations: designationCount === 0,
    workShifts: workShiftCount === 0,
  };
  const ready =
    !missing.departments && !missing.designations && !missing.workShifts;
  return { ready, missing };
};

export const evaluateSetupFromDropDownData = (dropDownData = {}) =>
  buildMissingSetup({
    departmentCount: dropDownData?.departments?.length || 0,
    designationCount: dropDownData?.designations?.length || 0,
    workShiftCount: dropDownData?.WorkShifts?.length || 0,
  });

/** Uses existing org list endpoints (department, designation, workshift). */
export async function fetchEmployeeSetupStatus(orgId) {
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  const [deptRes, desigRes, shiftRes] = await Promise.all([
    axios.get(`${MAIN_URL}/api/organizations/${orgId}/department`, { headers }),
    axios.get(`${MAIN_URL}/api/organizations/${orgId}/designation`, { headers }),
    axios.get(`${MAIN_URL}/api/organizations/${orgId}/workshift`, { headers }),
  ]);

  const departments = parseOrgList(deptRes.data, "Departments");
  const designations = parseOrgList(desigRes.data, "organizationdesignation");
  const workShifts = parseOrgList(shiftRes.data, "workshifts");

  return buildMissingSetup({
    departmentCount: departments.length,
    designationCount: designations.length,
    workShiftCount: workShifts.length,
  });
}
